<style lang="scss" scoped>
.twitter-input-form {
  background-color: #eee;
  padding: 15px;
  margin: 0 0 10px;

  h2 {
    font-size: 14px;
    margin: 0 0 10px;
  }
}
.btn-normal {
  margin-top: 5px;
}
</style>
<template>
  <div class="twitter-input">
    <div class="twitter-input-form" v-if="isEditing">
      <h2>Twitter</h2>
      <div class="form-group">
        <input
          type="text"
          class="form-control"
          placeholder="TwitterのURL"
          v-model="tweet_url"
        />
        <a @click="onCheck()" class="btn-normal">チェック</a>
      </div>
      <div class="tweet-wrap" data-tweet-wrap-preview></div>

      <div class="btn-group">
        <a class="btn-green" @click="onEndEdit()">追加</a>
        <a class="btn-green" @click="onDeleteInput()">削除</a>
      </div>
    </div>
    <div class="twitter-input-preview input-preview" v-else>
      <div class="tweet-wrap" data-tweet-wrap></div>
      <footer-menu
        :onBeginEdit="onBeginEdit"
        :onDeleteInput="onDeleteInput"
        :onPullUp="onPullUp"
        :onPullDown="onPullDown"
        :index="index"
      />
    </div>
  </div>
</template>

<script>
import footerMenu from './input-footer-menu.vue';
export default {
  props: {
    index: Number,
    value: {},
    id: String,
  },
  computed: {
    bodyJSON() {
      return {
        value: {
          tweet_url: this.tweet_url,
          html: this.html,
        },
        action: 'tweet',
      };
    },
    valid() {
      return this.html && this.html.length;
    },
  },
  components: {
    'footer-menu': footerMenu,
  },
  mounted() {
    this.tweet_url = this.value.tweet_url;
    this.html = this.value.html;

    this.$nextTick(() => {
      $(this.$el).find('[data-tweet-wrap]').html(this.html);
    });
  },
  methods: {
    renderTwitter() {
      this.$nextTick(() => {
        $(this.$el).find('[data-tweet-wrap]').html(this.html);
      });
    },
    onBeginEdit() {
      this.isEditing = true;
    },
    onEndEdit() {
      if (!this.valid) {
        alert('チェックを完了してください。');
        return false;
      }
      this.isEditing = false;
      this.$nextTick(() => {
        $(this.$el).find('[data-tweet-wrap]').html(this.html);
      });
    },
    onDeleteInput() {
      bus.$emit('delete-input', this.index);
    },
    onPullUp() {
      bus.$emit('pull-up-item', this.index);
    },
    onPullDown() {
      bus.$emit('pull-down-item', this.index);
    },
    alertURL() {
      alert('URLが間違っているか、ネットワークエラーが発生しています。');
      return false;
    },
    onCheck() {
      const date = new Date();
      $.ajax({
        url: '/api/tweet?' + date.getTime(),
        cache: false,
        data: {
          url: this.tweet_url,
        },
        type: 'get',
        success: (data) => {
          if (data.status != 'ok') {
            this.alertURL();
          }
          $(this.$el).find('[data-tweet-wrap-preview]').html(data.html);
          this.html = data.html;
        },
        error: () => {
          this.alertURL();
        },
      });
    },
  },
  data() {
    return {
      isEditing: false,
      tweet_url: '',
      html: '',
    };
  },
};
</script>
